"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.divisionFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Mocks = require("../../../mocks");
exports.divisionFactory = Factory.Sync.makeFactory({
    created_at: Mocks.dates.date2000,
    id: Factory.each(i => uuid_1.v4()),
    name: 'Test Division',
    org_id: 26369,
    originator_id: '2',
    originator_system: 'Ngin',
    originator_type: 'DivisionInstance',
    parent_division_ids: [],
    program_id: Factory.each(i => uuid_1.v4()),
    short_name: 'TD',
    status: 'Active',
    updated_at: Mocks.dates.date2000,
});
